const MAIN_URL = 'https://mobile.karat-med.ru'

export {
    MAIN_URL
}